import { UserManagementIcon } from 'core/components/Icons'
import { Column, Table } from 'core/components/ui/Table'
import React from 'react'
import { OnboardingRow } from '../../../domain/entities/SalesReport'
import { SectionCard } from './SectionCard'
import { PAIRED_TABLE_BODY_HEIGHT } from './format'

interface FpoFarmerOnboardingTableProps {
  rows: OnboardingRow[]
  loading?: boolean
}

export const FpoFarmerOnboardingTable: React.FC<FpoFarmerOnboardingTableProps> = ({ rows, loading = false }) => {
  const columns: Column<OnboardingRow>[] = [
    {
      key: 'fpoName',
      label: 'FPO Name',
      render: (row) => <span className="font-semibold text-text-primary">{row.fpoName}</span>,
    },
    { key: 'previousFarmers', label: 'Previous Farmers' },
    {
      key: 'todayFarmers',
      label: "Today's Farmers",
      render: (row) => (
        <span className={row.todayFarmers > 0 ? 'font-bold text-status-active' : 'text-text-secondary'}>
          {row.todayFarmers > 0 ? `+${row.todayFarmers}` : row.todayFarmers}
        </span>
      ),
    },
    {
      key: 'totalFarmers',
      label: 'Total Farmers',
      render: (row) => <span className="font-bold text-text-primary">{row.totalFarmers}</span>,
    },
  ]

  return (
    <SectionCard title="FPO Farmer Onboarding" subtitle="Cumulative farmers reached, by FPO">
      <Table
        columns={columns}
        data={rows}
        loading={loading}
        emptyMessage="No onboarding records."
        emptyIcon={<UserManagementIcon size={20} className="opacity-60" />}
        bodyHeight={PAIRED_TABLE_BODY_HEIGHT}
      />
    </SectionCard>
  )
}
